import axios from '@/plugins/axios.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('courseTemplate');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.searchTag.state,
        ...EdverumTable.searchGroup.state,
        ...EdverumTable.searchCourseCode.state,
        ...EdverumTable.searchCourseType.state,
        ...EdverumTable.viewArchived.state,
        assignableCourseTypes: [],
    },

    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
        ...EdverumTable.searchGroup.getters,
        ...EdverumTable.searchCourseCode.getters,
        ...EdverumTable.searchCourseType.getters,
        ...EdverumTable.viewArchived.getters,
    },

    actions: {
        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags(
            '/api/tags?type=course_template&model=CourseTemplate'
        ),
        fetchAssignableCourseCodes: collectionHelpers.actions.fetchAssignableCourseCodes(),
        fetchAssignableCourseTypes: async context => {
            const viewArchived = context.rootGetters['CourseTemplatesView/searchViewArchive'];
            const params = viewArchived ? { view_archived: 1 } : {};

            const { data } = await axios.get('/api/course-templates/filters', { params });

            context.commit('SET_ASSIGNABLE_COURSE_TYPES', data.courseTypes ?? []);

            return data.courseTypes;
        },
        reset: collectionHelpers.actions.reset('CourseTemplatesView'),
        clearSort: collectionHelpers.actions.clearSort,
        fetchAssignableGroups: collectionHelpers.actions.fetchAssignableGroups(),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.searchTag.mutations,
        ...EdverumTable.searchGroup.mutations,
        ...EdverumTable.searchCourseCode.mutations,
        ...EdverumTable.searchCourseType.mutations,
        SET_ASSIGNABLE_GROUPS: collectionHelpers.mutations.SET_ASSIGNABLE_GROUPS,
        SET_ASSIGNABLE_COURSE_TYPES(state, courseTypes) {
            state.assignableCourseTypes = courseTypes;
        },

        CLEAR_SORTING() {
            // Method called from EdverumTable.actions.reset()
        },
    },
};
